import { SVGProps } from 'react';

export default function Facebook(props: Partial<SVGProps<any>>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none"  {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M21 10.5C26.775 10.5 31.5 15.225 31.5 21C31.5 26.25 27.6938 30.7125 22.4438 31.5V24.0187H24.9375L25.4625 21H22.575V19.0312C22.575 18.2437 22.9688 17.4563 24.2812 17.4563H25.5938V14.8313C25.5938 14.8313 24.4125 14.5688 23.2313 14.5688C20.8688 14.5688 19.2937 16.0125 19.2937 18.6375V21H16.6687V24.0187H19.2937V31.3687C14.3062 30.5812 10.5 26.25 10.5 21C10.5 15.225 15.225 10.5 21 10.5Z" className='fill-[#FF00FE] dark:fill-white' />
    </svg>
  )
}